import { setParamAndRedirect } from '../../ItemList/helpers';

const hasRequiredItemListDetails = ({ itemListName, router, itemListId, queryItemListId }) => {
  if (!itemListName) return true;

  if (!queryItemListId && itemListId) {
    setParamAndRedirect(router, itemListId);
    return false;
  }

  return !!queryItemListId;
};

export default hasRequiredItemListDetails;
